const sliderImages = document.querySelectorAll('.slider-image');
const modal = document.querySelector('.modal');
const modalClose = document.querySelector('.modal-close');

sliderImages.forEach((image) => {
    image.addEventListener('click', () => {
        
        const modalImage = document.querySelector('.modal-image');
        const imageSrc = image.getAttribute('data-full-image');

        modalImage.src = imageSrc;
        modal.classList.add('open');

        // html overflow hidden
        document.querySelector('html').style.overflow = 'hidden';
    });
}); 


// close modal
modalClose.addEventListener('click', () => {
    modal.classList.remove('open');

    // html overflow auto
    document.querySelector('html').style.overflow = 'auto';
});

// close when clicked outside 
modal.addEventListener('click', (e) => {
    if(e.target.classList.contains('modal')) {
        modal.classList.remove('open');
        document.querySelector('html').style.overflow = 'auto';
    }
});